export default function Terms() {
  return (
    <main style={{ padding: "40px", maxWidth: "1000px", margin: "auto" }}>
      <h1>Terms & Conditions</h1>

      <iframe
        src="https://merchant.razorpay.com/policy/S2KjQ8ckWXnkCw/terms"
        title="Terms and Conditions"
        width="100%"
        height="1200"
        style={{ border: "none" }}
      />
    </main>
  );
}